import '../Styles/styles.scss'
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/modal';
import 'lazysizes';

import { expandableList } from './expandableList';
import { slider } from './slider';
import { maps } from './maps';
import { metermaps } from './metermap';
import { matomo } from './matomo';
import { elementscroll } from './elementscroll';
import { stickymenu } from './stickymenu';
import { formValidation } from './form-validation';
import { iframe } from './iframe';
import { recycleareamap } from './recycleareamap';
import { fullheight } from './fullheight';
import { chart } from './chart';
import { cookies } from './cookies';
import { kundo } from './kundo';
import { scrollParentToElement } from './utils';

window.expandableList = expandableList;
window.slider = slider;
window.maps = maps;
window.scrollParentToElement = scrollParentToElement;
window.metermaps = metermaps;
window.fullheight = fullheight;
window.recycleareamap = recycleareamap;
window.matomo = matomo;
window.elementscroll = elementscroll;
window.stickymenu = stickymenu;
window.formValidation = formValidation;
window.iframe = iframe;
window.chart = chart;
window.cookies = cookies;
window.kundo = kundo;

